import { render, staticRenderFns } from "./eventDetails.vue?vue&type=template&id=f49ad328&scoped=true&"
import script from "./eventDetails.vue?vue&type=script&lang=js&"
export * from "./eventDetails.vue?vue&type=script&lang=js&"
import style0 from "./eventDetails.vue?vue&type=style&index=0&id=f49ad328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49ad328",
  null
  
)

component.options.__file = "eventDetails.vue"
export default component.exports